/**
 * Was die Fehlerseite an das Feedback-Formular weitergibt (Plan s6 A7).
 * Eigene Datei, weil eine Komponenten-Datei nur Komponenten exportieren soll
 * (Fast Refresh, siehe `route-shells.tsx`).
 */

import { isRouteErrorResponse } from 'react-router-dom';

/** Was als Fehlermeldung mitgeht: die Meldung, nie der Stacktrace (Spec D12). */
export function errorText(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`.trim();
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  return '';
}

/** `/e/feedback?thema=technisches-problem&seite=…&fehler=…` */
export function problemReportHref(pathname: string, message: string): string {
  const params = new URLSearchParams({
    thema: 'technisches-problem',
    seite: pathname.slice(0, 300),
  });
  const fehler = message.trim().slice(0, 500);
  if (fehler) params.set('fehler', fehler);
  return `/e/feedback?${params.toString()}`;
}
